import * as React from "react";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { fetchStatsForSingleRouteAgreementCalculation } from "../thunks/StatsForSingleRouteAgreementCalculationFetcher";
import { useRecalculationOfPriceRowsIsRequiredBeforeSave } from "../hooks/UseRecalculationOfPriceRowsIsRequiredBeforeSave";
import { RecalculationBoxPanel } from "./RecalculationBoxPanel";
import { Spacing } from "@stenajs-webui/core";
import { fetchActualChangeForAllPriceRows } from "../../../rate-sheet/thunks/FetchActualChangeForAllPriceRows";
import { refetchStatBoxesWithRateSheetsChanges } from "../../../../customer-route-statistic-boxes/thunks/RefetchStatBoxesWithRateSheetsChanges";

interface Props {
  routeAgreementId: string;
  customerId: string;
  editableRouteAgreement: boolean;
}

export const RecalculationBoxForSingleRouteAgreement: React.FC<Props> = ({
  routeAgreementId,
  customerId,
  editableRouteAgreement,
}) => {
  const dispatch = useDispatch();
  const { recalculationOfPriceRowsIsRequiredBeforeSave } =
    useRecalculationOfPriceRowsIsRequiredBeforeSave(
      routeAgreementId,
      editableRouteAgreement
    );

  const onClickRecalculate = useCallback(async () => {
    await dispatch(
      fetchStatsForSingleRouteAgreementCalculation(routeAgreementId, customerId)
    );
    await dispatch(fetchActualChangeForAllPriceRows());
    await dispatch(refetchStatBoxesWithRateSheetsChanges());
  }, [dispatch, routeAgreementId, customerId]);

  if (!recalculationOfPriceRowsIsRequiredBeforeSave) {
    return null;
  }

  return (
    <>
      <RecalculationBoxPanel onClickRecalculate={onClickRecalculate} />
      <Spacing />
    </>
  );
};
